import { FC } from "react";
import {
  OngoingProjectSection,
  PartnerSection,
  FaqSection,
  FeatureSection,
} from "components";
import { HeroSection } from "./components/HeroSection";
import { features } from "./constant";

export const OwnerPage: FC = () => {
  return (
    <>
      <HeroSection />
      <PartnerSection />
      <FeatureSection features={features} />
      <OngoingProjectSection />
      <FaqSection />
    </>
  );
};
